<template>
  <div>
    <h1>Intro</h1>
    <h2>Wilkommen bei MeteOhr.</h2>
    <div align="center">
      <div class="card shadow-sm p-3 mb-5 bg-white rounded" style="width: 40%">
        <img class="card-img-top" src="@/assets/introbild.jpg" alt="Card image cap">
        <h5 class="card-title">Über diese Seite</h5>
        <div class="card-body">
          Der interaktiven Seite zum erlernen von Aufbau und Funktion des Ohrs 
          wie auch zur Signalverarbeitung. Im Folgenden durchlauft ihr verschiedene Stationen und Quizze, 
          die euch diese Inhalte näher bringen. <br> Viel Spaß! <br>
        </div>
        
      </div>
    </div>
  </div>
  
</template>

<script>
export default {
  data() {
    return {
      stylez: "btn btn-secondary",
    };
  },
  toggle() {
    this.stylez = "btn btn-primary";
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
body {
  background-color: brown;
}
h1 {
  font-size: 300%;
}
h2 {
  font-size: 250%;
  padding: 10px;
}
h3 {
  text-align: left;
  /* padding-left: 250px; */
  font-size: 150%;
}

</style>
